// extracted by mini-css-extract-plugin
export default {"sign":"sign","sign_canvas":"sign_canvas","sign_line":"sign_line","sign_clear":"sign_clear"};